'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.second;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/second.js
// module id = 729
// module chunks = 0